module.exports = __webpack_public_path__ + "static/img/klt1350-fcm-325-75bb.b8f09fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/klt1350-fcm-325-75bb.jpg
// module id = 0krt
// module chunks = 0